import langs from './langs';

const date = ts => new Date(typeof ts == 'number' ? ts * 1000 : ts.slice(0, 10));
const dateToIso = ts => date(ts).toISOString().replace(/-/g, '/').replace('T', ' ');
const formatDate = (ts, lang = 'es') => dateToIso(ts).slice(0, 10).split('/').reverse().join(langs[lang].dateSeparator || '/');

const formatLongDate = (ts, lang = 'es') => {
    let fullDate = date(ts);
    let weekDay = langs[lang].days[fullDate.getDay()];
    let longDate = `${ weekDay } ${ fullDate.toISOString().slice(0, 10) }`;
    return longDate.replace(/^(.+)\s(\d{2})(\d{2})-(\d{2})-(\d{2})$/i, langs[lang].longDateFormat || '$1 $5/$4/$3');
};

const formatMonthDate = (ts, lang = 'es') => {
    let fullDate = date(ts);
    let weekDay = langs[lang].days[fullDate.getDay()];
    let monthName = langs[lang].months[fullDate.getMonth()];
    let day = fullDate.getDate();
    let year = fullDate.getFullYear();

    let longDate = `${ weekDay } ${ day } ${ monthName } ${ year }`;
    return longDate.replace(/^(.+)\s(\d{1,2})\s(.+)\s(\d{4})$/i, langs[lang].monthDateFormat || '$1 $2 $3 $4');
};

export { formatDate, formatLongDate, formatMonthDate };
